// @flow

import axios from "axios";
import { EXTERNAL_CONNECTION_ERRORS } from "./constants";

const deleteAppRecord = async (appRecordId: string, user: AppRecord) => {
  try {
    const deleteResult = await axios.delete("/api/shared/delete-app-record", {
      data: {
        appRecordId,
        userId: user.id,
        userGroup: user.group
      }
    });
    return deleteResult;
  } catch (error) {
    console.error("Utils - Get application record - Error:", error);
    throw new Error(EXTERNAL_CONNECTION_ERRORS.DELETE_RECORD);
  }
};

export default deleteAppRecord;
